import MyPunchesByMonthPage from "./MyPunchesByMonthPage";

export default {
    list: MyPunchesByMonthPage
}